import { IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";

import { DogTitleSearch, TransientDogTitlesApi } from "../../../../api";
import { useEventsContext, useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalDataTable } from "../../../common";

export interface IDrupalDogForeignTitleGridProps {
  dogId: number;
}

export const DrupalDogForeignTitleGrid: React.FunctionComponent<IDrupalDogForeignTitleGridProps> = ({ dogId }) => {
  const transientApi = useApiService(TransientDogTitlesApi);
  const { t } = useTl();
  const { currentLanguage } = useGlobalData();

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [5, 10, 15],
    pageSize: 10,
    sortKeys: { createdOn: "DESC" },
  });

  const searchFunction = React.useCallback(
    (sObj?: DogTitleSearch) => {
      return transientApi.searchByDog(
        DogTitleSearch.fromJS({ ...sObj, dogId: dogId, languageId: currentLanguage.languageId })
      );
    },
    [currentLanguage.languageId, dogId, transientApi]
  );

  const { search, loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });
  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Name),
        fieldName: "titleName",
      },
      {
        header: () => t(ETLCodes.Country),
        fieldName: "country",
      },
      {
        header: () => t(ETLCodes.Type),
        fieldName: "titleType",
      },
      {
        header: () => t(ETLCodes.Year),
        fieldName: "year",
      },
      {
        header: () => t(ETLCodes.CreationDate),
        fieldName: "createdOn",
      },
    ],
    [t]
  );

  const { subscribeToEvent, unsubscribeEvent } = useEventsContext();
  React.useEffect(() => {
    subscribeToEvent("RefreshSearchTables", search);
    return () => unsubscribeEvent("RefreshSearchTables", search);
  }, [search, subscribeToEvent, unsubscribeEvent]);

  return <DrupalDataTable tableState={tableState} loading={loading} columns={columns} keyFieldName="dogTitleId" />;
};
